import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import axiosInstance from '../../config/axios';
import { storage } from '../../services/storage';
import { loginSuccess, loginFailure } from '../reducers/authReducer';

function* handleSAMLCallback(token: string): Generator<any, void, any> {
  try {
    // Decode token to get user info (in production, verify on server)
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const user = JSON.parse(jsonPayload);

    yield put(loginSuccess({ user, token }));
  } catch (error: any) {
    yield put(loginFailure(error.message || 'Authentication failed'));
  }
}

function* fetchCurrentUser(): Generator<any, void, any> {
  try {
    const token: string | null = yield call([storage, storage.getItem], 'token');
    if (token) {
      const response: AxiosResponse = yield call(axiosInstance.get, '/api/auth/me');
      
      if (response.data.success) {
        yield put(loginSuccess({ user: response.data.user, token }));
      }
    }
  } catch (error: any) {
    console.error('Failed to fetch current user:', error);
  }
}

function* logout(): Generator<any, void, any> {
  try {
    yield call(axiosInstance.post, '/api/auth/logout', {});
  } catch (error) {
    console.error('Logout error:', error);
  }
}

export default function* authSaga() {
  yield takeLatest('auth/checkToken', fetchCurrentUser);
  yield takeLatest('auth/handleSAMLCallback', function* (action: any) {
    yield call(handleSAMLCallback, action.payload);
  });
  yield takeLatest('auth/logout', logout);
}